import { z } from 'zod'
import interceptedAxios from '../../../utils/interceptedAxios'

const ZBulkUploadFailureReason = z.object({
  row_number: z.number(),
  reason: z.string()
})

const ZBulkUploadResult = z.object({
  total_rows: z.number(),
  success_count: z.number(),
  failure_count: z.number(),
  failure_reasons: z.array(ZBulkUploadFailureReason)
})

const ZBulkUploadApiResponse = z.object({
  http_status: z.number(),
  error: z.boolean(),
  data: ZBulkUploadResult
})

export type BulkUploadFailureReason = z.infer<typeof ZBulkUploadFailureReason>
export type BulkUploadResult = z.infer<typeof ZBulkUploadResult>

export async function bulkUploadAssets (
  file: File,
  onSuccess: (successResponse: BulkUploadResult, httpStatus: number) => any,
  onFailure: (errorMessage: string, httpStatus: number) => any
): Promise<void> {
  const url = '/assetrest/api/v2/udp/tiq/assets/asset-management/bulk-upload'
  const formData = new FormData()

  formData.append('file', file)

  interceptedAxios
    .post(url, formData, {
      timeout: 45000
    })
    .then((response) => {
      const parseResponse = ZBulkUploadApiResponse.safeParse(response.data)

      if (parseResponse.success) {
        onSuccess(parseResponse.data.data, parseResponse.data.http_status)
      } else {
        onFailure('Error occurred while processing bulk upload response', response.status)
      }
    })
    .catch((error) => {
      if (error.response !== undefined) {
        if (error.response.data !== undefined) {
          onFailure(error.response.data.error_message ?? error.response.data.message ?? 'Bulk upload failed', error.response.data.http_status ?? error.response.status)
        } else {
          onFailure(error.response.statusText, error.response.status)
        }
      } else {
        onFailure('Network Failure', error.status)
      }
    })
}
